export const STATUS = {
  ACTIVE: "active",
  IN_ACTIVE: "in-active",
};

export const STATUS_TEXT = {
  ACTIVE: "เปิดการแสดงผล",
  IN_ACTIVE: "ซ่อนการแสดงผล",
};

export const STATUS_OPTIONS = [
  { value: STATUS.ACTIVE, text: STATUS_TEXT.ACTIVE },
  { value: STATUS.IN_ACTIVE, text: STATUS_TEXT.IN_ACTIVE },
];
